import { Flex, Button, Icon } from "@chakra-ui/react";
import GlobeIcon from "@root/assets/icons/Globeicon";
import { useTranslation } from "react-i18next";
import useLanguage from "@root/hooks/useLanguage";

export const LanguageToggle = ({
  languages,
  isSidebarOpen,
  marginBottom = "5",
  maxWidth = "200px",
}: any) => {
  const { t } = useTranslation("common");
  const { currentLanguage, handleUpdateLanguage } = useLanguage();

  // Removed useEffect that was forcing Korean on mount
  // Language is now loaded from localStorage on app initialization

  // DEBUG: Log current language
  console.log("currentLanguage from Redux:", currentLanguage);
  console.log("Type:", typeof currentLanguage);

  const handleLanguageChange = (langValue: string) => {
    handleUpdateLanguage(langValue);
  };

  return (
    <Flex
      data-tour-item="sidebar-language-toggle"
      alignItems="center"
      bg="#F3F4F6"
      borderRadius="10px"
      fontWeight="500"
      fontSize="14px"
      p="4px"
      h="38px"
      color="#2F2F34"
      maxW={maxWidth}
      mb={marginBottom}
      justifyContent="center"
      visibility={isSidebarOpen ? "visible" : "hidden"}
    >
      <Icon as={GlobeIcon} boxSize={5} color="#5C6670" />
      {languages?.map((lang: any) => (
        <Button
          key={lang?.labelKey}
          onClick={() => handleLanguageChange(lang?.value)} // function call
          size="sm"
          variant={currentLanguage === lang?.value ? "solid" : "ghost"}
          bg={currentLanguage === lang?.value ? "white" : "transparent"}
          borderRadius="8px"
          color="#5C6670"
          _hover={{ bg: "white" }}
          _focus={{
            boxShadow: "none",
            outline: "none",
          }}
        >
          {isSidebarOpen ? t(lang?.labelKey) : t(lang?.shortKey)}
        </Button>
      ))}
    </Flex>
  );
};
